export enum EMAIL_NAMES {
	newUserTemplate = 'NewUserTemplate',

	//
	resetPasswordTemplate = 'ResetPasswordTemplate',
	changePasswordTemplate = 'ChangePasswordTemplate ',

	//
	invitationEmailTest = 'EmailTemplateTest',

	invitationEmail = 'InvitationEmail',
	reminderRatings = 'ReminderEmailRatings',
	reminderEvaluation = 'ReminderEmailEvaluation',
}

export enum EMAIL_ADDRESSES {
	from = 'IT Experience Survey <it.experience.survey@voxxify.com>',
}
